module.exports = __webpack_public_path__ + "img/burger.f77d225d.svg";